'use client'

import { AuthProvider } from './AuthProvider'
import { CartProvider } from './CartProvider'
import { WishlistProvider } from './WishlistProvider'

export function CommerceProviders({ vendor, customer, initialWishlist, initialLoyaltySummary, initialLoyaltyCategoryParents, children }: { vendor: any, customer: any, initialWishlist?: any, initialLoyaltySummary?: any, initialLoyaltyCategoryParents?: Record<string, string | null>, children: React.ReactNode }) {
  return (
    <AuthProvider vendor={vendor} initialCustomer={customer}>
      <CartProvider vendor={vendor} initialLoyaltySummary={initialLoyaltySummary} initialLoyaltyCategoryParents={initialLoyaltyCategoryParents}>
        <WishlistProvider initialWishlist={initialWishlist || null}>
          {children}
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  )
}

export default CommerceProviders
